import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { Box } from '@mui/joy';
import { Sidebar } from '@/components/Sidebar';

export const Route = createFileRoute('/_protected')({
  component: ProtectedLayout,
});

function ProtectedLayout() {
  const sidebarWidth = 280;

  return (
    <ProtectedRoute>
      <Box sx={{ display: 'flex', minHeight: '100vh' }}>
        <Sidebar width={sidebarWidth} />
        <Box
          component='main'
          sx={{
            flexGrow: 1,
            backgroundColor: 'background.surface',
            marginLeft: { xs: 0, md: `${sidebarWidth}px` },
            minHeight: '100vh',
            paddingTop: { xs: '80px', md: 2 },
            paddingX: 2,
            width: { xs: '100%', md: `calc(100% - ${sidebarWidth}px)` },
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </ProtectedRoute>
  );
}
